export default __webpack_public_path__ + "static/media/29.af819350.jpg";